<ngb-progressbar [showValue]="showValue" [value]="currentValue" [max]="maxValue">{{ customLabel }}</ngb-progressbar>
